/**
 * Cart drawer upsell carousel + shared cart toast helper
 */
(function () {
  if (!window.themeCartToast) {
    var toastTimer = null;
    window.themeCartToast = function (message, duration, variant) {
      if (!message) return;
      var el = document.getElementById('theme-cart-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'theme-cart-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
      }
      el.className = 'cart-toast' + (variant === 'success' ? ' cart-toast--success' : '');
      el.textContent = message;
      el.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, duration || (variant === 'success' ? 2000 : 3200));
    };

    window.themeCartErrorMessage = function (response, data, fallback) {
      if (response && response.status === 429) {
        return 'Too many requests. Please wait a moment and try again.';
      }
      if (data) {
        if (data.description) return data.description;
        if (data.message) return data.message;
        if (typeof data === 'string' && data.trim()) return data;
      }
      if (response && response.status >= 500) {
        return 'Server error. Please try again in a moment.';
      }
      return fallback || 'Could not update your cart. Please try again.';
    };
  }
})();

if (!customElements.get('cart-drawer-promo')) {
  class CartDrawerPromo extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.timer = null;
      this.resumeTimer = null;
      this.animTimer = null;
      this.isPointerDown = false;
      this.isAnimating = false;
      this.ignoreScrollSync = false;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.didDrag = false;
      this.onAdd = this.onAdd.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('[data-cart-promo-viewport]');
      this.track = this.querySelector('[data-cart-promo-track]');
      this.dots = this.querySelector('[data-cart-promo-dots]');
      this.slides = Array.from(this.querySelectorAll('[data-cart-promo-slide]'));
      this.autoplayMs = Number(this.getAttribute('data-autoplay-ms') || 2500);
      this.resumeMs = Number(this.getAttribute('data-resume-ms') || 8000);

      this.addEventListener('click', this.onAdd);
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('visibilitychange', this.onVisibility);

      if (this.viewport) {
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.viewport.addEventListener('pointermove', this.onPointerMove, { passive: true });
        this.viewport.addEventListener('touchstart', this.onPointerDown, { passive: true });
        this.viewport.addEventListener('touchmove', this.onPointerMove, { passive: true });
        this.viewport.addEventListener('pointerup', this.onPointerUp, { passive: true });
        this.viewport.addEventListener('pointercancel', this.onPointerUp, { passive: true });
        this.viewport.addEventListener('touchend', this.onPointerUp, { passive: true });
        this.viewport.addEventListener('mouseenter', () => this.pauseAutoplay(false));
        this.viewport.addEventListener('mouseleave', () => {
          if (!this.isPointerDown) this.scheduleResume();
        });
      }

      this.addEventListener('focusin', (event) => {
        if (event.target.closest('[data-cart-promo-add]')) this.pauseAutoplay(false);
      });
      this.addEventListener('pointerenter', (event) => {
        if (event.target && event.target.closest && event.target.closest('[data-cart-promo-add]')) {
          this.pauseAutoplay(false);
        }
      }, true);

      this.buildDots();
      this.goTo(0, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.clearTimers();
      this.removeEventListener('click', this.onAdd);
      this.removeEventListener('change', this.onVariantChange);
      this.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.viewport) {
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointermove', this.onPointerMove);
        this.viewport.removeEventListener('touchstart', this.onPointerDown);
        this.viewport.removeEventListener('touchmove', this.onPointerMove);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);
        this.viewport.removeEventListener('touchend', this.onPointerUp);
      }
    }

    get canAutoplay() {
      return this.slides.length > 1 && document.visibilityState !== 'hidden';
    }

    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.resumeTimer) {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = null;
      }
      if (this.animTimer) {
        clearTimeout(this.animTimer);
        this.animTimer = null;
      }
    }

    startAutoplay() {
      this.clearTimers();
      if (!this.canAutoplay) return;
      this.timer = setInterval(() => {
        if (this.isPointerDown || this.isAnimating) return;
        this.goTo(this.index + 1, true);
      }, this.autoplayMs);
    }

    pauseAutoplay(scheduleResume = true) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (scheduleResume) this.scheduleResume();
    }

    scheduleResume() {
      if (this.resumeTimer) clearTimeout(this.resumeTimer);
      if (!this.canAutoplay) return;
      this.resumeTimer = setTimeout(() => {
        this.resumeTimer = null;
        if (!this.isPointerDown) this.startAutoplay();
      }, this.resumeMs);
    }

    markManualInteraction() {
      this.pauseAutoplay(true);
    }

    getEventPoint(event) {
      if (event.touches && event.touches[0]) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
      if (event.changedTouches && event.changedTouches[0]) {
        return { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }
      return { x: event.clientX || 0, y: event.clientY || 0 };
    }

    onPointerDown(event) {
      if (event.target && event.target.closest('[data-cart-promo-add], [data-cart-promo-variant-select], a, button, select')) {
        this.isPointerDown = false;
        this.didDrag = false;
        this.pauseAutoplay(true);
        return;
      }
      const point = this.getEventPoint(event);
      this.pointerStartX = point.x;
      this.pointerStartY = point.y;
      this.didDrag = false;
      this.isPointerDown = true;
      this.markManualInteraction();
    }

    onPointerMove(event) {
      if (!this.isPointerDown || this.didDrag) return;
      const point = this.getEventPoint(event);
      const dx = Math.abs(point.x - this.pointerStartX);
      const dy = Math.abs(point.y - this.pointerStartY);
      if (dx > 8 || dy > 8) {
        this.didDrag = true;
      }
    }

    onPointerUp() {
      this.isPointerDown = false;
      this.syncIndexFromScroll();
      this.scheduleResume();
    }

    onVisibility() {
      if (document.visibilityState === 'hidden') {
        this.pauseAutoplay(false);
      } else {
        this.scheduleResume();
      }
    }

    onKeyDown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (!this.slides.length) return;
      event.preventDefault();
      this.markManualInteraction();
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1, true);
      else this.goTo(this.index + 1, true);
    }

    onScroll() {
      if (this.ignoreScrollSync || this.isPointerDown) return;
      window.requestAnimationFrame(() => this.syncIndexFromScroll());
    }

    syncIndexFromScroll() {
      if (!this.viewport || !this.slides.length) return;
      const width = this.viewport.clientWidth || 1;
      const next = Math.round(this.viewport.scrollLeft / width);
      const clamped = Math.max(0, Math.min(next, this.slides.length - 1));
      if (clamped !== this.index) {
        this.index = clamped;
        this.updateActiveSlide();
        this.updateDots();
      }
    }

    updateActiveSlide() {
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
      });
    }

    buildDots() {
      if (!this.dots) return;
      if (this.slides.length < 2) {
        this.dots.hidden = true;
        this.dots.innerHTML = '';
        return;
      }
      this.dots.hidden = false;
      this.dots.innerHTML = this.slides
        .map((_, i) => `<button type="button" class="cart-drawer-promo__dot" data-cart-promo-dot="${i}" aria-label="Slide ${i + 1}"></button>`)
        .join('');
      this.dots.querySelectorAll('[data-cart-promo-dot]').forEach((dot) => {
        dot.addEventListener('click', this.onDotClick);
      });
      this.updateDots();
    }

    updateDots() {
      this.dots?.querySelectorAll('[data-cart-promo-dot]').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
    }

    onDotClick(event) {
      const button = event.currentTarget;
      const index = Number(button.getAttribute('data-cart-promo-dot'));
      this.markManualInteraction();
      this.goTo(index, true);
    }

    goTo(index, animate = true) {
      if (!this.slides.length || !this.viewport) return;
      const total = this.slides.length;
      const next = ((index % total) + total) % total;
      this.index = next;
      this.updateActiveSlide();
      this.updateDots();

      const left = this.viewport.clientWidth * next;
      this.ignoreScrollSync = true;
      this.isAnimating = animate;
      if (this.animTimer) clearTimeout(this.animTimer);
      this.viewport.scrollTo({
        left,
        behavior: animate ? 'smooth' : 'auto'
      });
      this.animTimer = window.setTimeout(() => {
        this.ignoreScrollSync = false;
        this.isAnimating = false;
        this.animTimer = null;
      }, animate ? 420 : 50);
    }

    onVariantChange(event) {
      const select = event.target.closest('[data-cart-promo-variant-select]');
      if (!select) return;
      this.markManualInteraction();
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const slide = select.closest('[data-cart-promo-slide]');
      if (!slide) return;

      const addButton = slide.querySelector('[data-cart-promo-add]');
      const priceEl = slide.querySelector('[data-cart-promo-price]');
      const compareEl = slide.querySelector('[data-cart-promo-compare]');
      const saveEl = slide.querySelector('[data-cart-promo-save]');

      if (addButton) addButton.setAttribute('data-variant-id', option.value);
      if (priceEl) priceEl.textContent = option.getAttribute('data-price-money') || '';

      const compareAt = Number(option.getAttribute('data-compare-at-price') || 0);
      const price = Number(option.getAttribute('data-price') || 0);
      const savePct = Number(option.getAttribute('data-save-percentage') || 0);

      if (compareEl) {
        if (compareAt > price) {
          compareEl.hidden = false;
          compareEl.textContent = option.getAttribute('data-compare-at-price-money') || '';
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (savePct > 0) {
          saveEl.hidden = false;
          saveEl.textContent = `SAVE ${savePct}%`;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    onAdd(event) {
      const button = event.target.closest('[data-cart-promo-add]');
      if (!button || !this.contains(button)) return;
      if (this.didDrag) {
        this.didDrag = false;
        return;
      }
      if (this.isAnimating) return;

      event.preventDefault();
      event.stopPropagation();
      this.markManualInteraction();

      const variantId = button.getAttribute('data-variant-id');
      if (!variantId || button.classList.contains('loading')) return;

      button.classList.add('loading');
      button.setAttribute('disabled', 'disabled');

      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      })
        .then(async (response) => {
          let data = null;
          try {
            data = await response.json();
          } catch (e) {
            data = null;
          }
          if (!response.ok) {
            const msg = window.themeCartErrorMessage(
              response,
              data,
              'Could not add to cart. Please try again.'
            );
            throw new Error(msg);
          }
          if (data && data.status) {
            const msg = window.themeCartErrorMessage(
              response,
              data,
              'Could not add to cart. Please try again.'
            );
            throw new Error(msg);
          }
          return data;
        })
        .then(() => {
          window.themeCartToast('Added to cart.', 2000, 'success');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch((error) => {
          console.error(error);
          window.themeCartToast(
            (error && error.message) || 'Could not add to cart. Please try again.'
          );
        })
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('disabled');
        });
    }
  }

  customElements.define('cart-drawer-promo', CartDrawerPromo);
}
